module.exports = __webpack_public_path__ + "static/media/workPvcCoatings4.75d9e223.jpg";